// extracted by mini-css-extract-plugin
module.exports = {"Report":"Report--3426u","header":"header--35hbw","content":"content--1kTlS"};